<section id="pricing" class="section pricing-section">
  <div class="container">
    <h2 class="section-title">Flexible Pricing Plans</h2>
    <p class="section-subtitle">
      Choose the perfect IP Telephony solution designed to scale with your
      business requirements.
    </p>

    <div class="pricing-grid">
      @if (plans && plans.length === 0) {
        <div class="no-data-fallback">No data found.</div>
      }
      <div
        *ngFor="let plan of plans || []; let i = index"
        class="pricing-card glass-card reveal"
        [ngClass]="{
          featured: plan.badge > 0,
          'delay-100': i % 3 === 0,
          'delay-200': i % 3 === 1,
          'delay-300': i % 3 === 2,
        }"
      >
        <div
          class="featured-badge badge-{{ plan.badgeInfo.name | lowercase }}"
          *ngIf="plan.badgeInfo && plan.badgeInfo.name !== 'Basic'"
        >
          {{ plan.badgeInfo.name }}
        </div>
        <h3 class="plan-name">{{ plan.name }}</h3>
        <div class="plan-price">
          {{
            plan.currency === "BDT"
              ? "৳"
              : plan.currency === "USD"
                ? "$"
                : plan.currency
          }}{{ plan.price | number
          }}<span *ngIf="plan.priceType">/{{ plan.priceType }}</span>
        </div>
        <p class="plan-desc">{{ plan.shortDescription }}</p>
        <ul class="plan-features">
          <li *ngFor="let item of plan.items">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            {{ item.item }}
          </li>
        </ul>
        <a
          [href]="plan.forwardLink || '#contact'"
          class="btn"
          [ngClass]="plan.badge > 0 ? 'btn-primary' : 'btn-outline'"
          >{{ plan.buttonTitle || "Choose " + plan.name }}</a
        >
      </div>
    </div>
  </div>
</section>
